var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['loading'])?_c('v-overlay',{attrs:{"color":"#EBF5FB"}},[_c('hollow-dots-spinner',{attrs:{"animation-duration":2500,"size":65,"color":"#137f4e"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }